const labelStyle = {

    "fontFamily": "Helvetica Neue,Helvetica,Arial,sans-serif",
    "letterSpacing": 0,
    "lineHeight": 1,
    "color": "#333333",
    "boxShadow": null,
    "background": null
}

const buttonStyle = {
    "fontSize": 14,
    "fontFamily": "Helvetica Neue,Helvetica,Arial,sans-serif",
    "textAlign": "center",
    "letterSpacing": 0,
    "lineHeight": 1,
    "color": "#FFFFFF",
    "paddingTop": 0,
    "paddingBottom": 0,
    "paddingLeft": 0,
    "paddingRight": 0,
    "borderTopRightRadius": 3,
    "borderTopLeftRadius": 3,
    "borderBottomRightRadius": 3,
    "borderBottomLeftRadius": 3,
    "borderTopWidth": 1,
    "borderBottomWidth": 1,
    "borderRightWidth": 1,
    "borderLeftWidth": 1,
    "verticalAlign": "middle",
    "borderTopColor": "#333333",
    "borderBottomColor": "#333333",
    "borderRightColor": "#333333",
    "borderLeftColor": "#333333",
    "background": "#333333",
    "boxShadow": null
}

const containerStyle = {
    "fontSize": 14,
    "fontFamily": "Helvetica Neue,Helvetica,Arial,sans-serif",
    "textAlign": "center",
    "letterSpacing": 0,
    "lineHeight": 1,
    "color": "#333333",
    "paddingTop": 0,
    "paddingBottom": 0,
    "paddingLeft": 0,
    "paddingRight": 0,
    "borderTopRightRadius": 3,
    "borderTopLeftRadius": 3,
    "borderBottomRightRadius": 3,
    "borderBottomLeftRadius": 3,
    "borderTopWidth": 1,
    "borderBottomWidth": 1,
    "borderRightWidth": 1,
    "borderLeftWidth": 1,
    "verticalAlign": "middle",
    "borderTopColor": "#333333",
    "borderBottomColor": "#333333",
    "borderRightColor": "#333333",
    "borderLeftColor": "#333333",
    "background": "#ffffff",
    "boxShadow": null
}

const defaultStyle = {
    "fontSize": 14,
    "fontFamily": "Helvetica Neue,Helvetica,Arial,sans-serif",
    "textAlign": "center",
    "letterSpacing": 0,
    "lineHeight": 1,
    "color": "#333333",
    "paddingTop": 0,
    "paddingBottom": 0,
    "paddingLeft": 0,
    "paddingRight": 0,
    "borderTopRightRadius": 3,
    "borderTopLeftRadius": 3,
    "borderBottomRightRadius": 3,
    "borderBottomLeftRadius": 3,
    "borderTopWidth": 1,
    "borderBottomWidth": 1,
    "borderRightWidth": 1,
    "borderLeftWidth": 1,
    "verticalAlign": "middle",
    "borderTopColor": "#333333",
    "borderBottomColor": "#333333",
    "borderRightColor": "#333333",
    "borderLeftColor": "#333333",
    "background": "#ffffff",
    "boxShadow": null
}

const defaultImage = {
    "borderTopRightRadius": 0,
    "borderTopLeftRadius": 0,
    "borderBottomRightRadius": 0,
    "borderBottomLeftRadius": 0,
    "borderTopWidth": 0,
    "borderBottomWidth": 0,
    "borderRightWidth": 0,
    "borderLeftWidth": 0,
    "borderTopColor": "#333333",
    "borderBottomColor": "#333333",
    "borderRightColor": "#333333",
    "borderLeftColor": "#333333",
    "backgroundImage": null
}



export const screenStyle = {
    "background": "#FFFFFF",
}

const textboxStyle = {
    "fontSize": 14,
    "fontFamily": "Helvetica Neue,Helvetica,Arial,sans-serif",
    "textAlign": "center",
    "letterSpacing": 0,
    "lineHeight": 1,
    "color": "#333333",
    "paddingTop": 0,
    "paddingBottom": 0,
    "paddingLeft": 4,
    "paddingRight": 4,
    "borderTopRightRadius": 3,
    "borderTopLeftRadius": 3,
    "borderBottomRightRadius": 3,
    "borderBottomLeftRadius": 3,
    "borderTopWidth": 1,
    "borderBottomWidth": 1,
    "borderRightWidth": 1,
    "borderLeftWidth": 1,
    "verticalAlign": "middle",
    "borderTopColor": "#333333",
    "borderBottomColor": "#333333",
    "borderRightColor": "#333333",
    "borderLeftColor": "#333333",
    "background": "#FFFFFF",
    "boxShadow": null
}


const tableStyle = {
    "fontSize": 14,
    "fontFamily": "Helvetica Neue,Helvetica,Arial,sans-serif",
    "textAlign": "center",
    "letterSpacing": 0,
    "lineHeight": 1,
    "borderTopRightRadius": 0,
    "borderTopLeftRadius": 0,
    "borderBottomRightRadius": 0,
    "borderBottomLeftRadius": 0,
    "borderTopWidth": 1,
    "borderBottomWidth": 1,
    "borderRightWidth": 1,
    "borderLeftWidth": 1,
    "borderTopColor": "#333333",
    "borderBottomColor": "#333333",
    "borderRightColor": "#333333",
    "borderLeftColor": "#333333",
    "background": "#fff",
    "color": "#333333",
    "paddingTop": 10,
    "paddingBottom": 10,
    "paddingLeft": 5,
    "paddingRight": 5,
    "headerFontWeight": "800",
    "headerBackground": "#333333",
    "headerSticky": true,
    "headerColor": "#fff",
    "checkBox": false,
    "checkBoxHookColor": "#333333",
    "checkBoxBackground": "#ffffff",
    "checkBoxBorderColor": "#333333",
    "checkBoxBorderRadius": 2,
    "checkBoxBorderWidth": 1
}

const dropdownStyle = {
    "borderTopRightRadius": 3,
    "borderTopLeftRadius": 3,
    "borderBottomRightRadius": 3,
    "borderBottomLeftRadius": 3,
    "borderTopWidth": 1,
    "borderBottomWidth": 1,
    "borderRightWidth": 1,
    "borderLeftWidth": 1,
    "borderTopColor": "#333333",
    "borderBottomColor": "#333333",
    "borderRightColor": "#333333",
    "borderLeftColor": "#333333",
    "background": "#ffffff",
    "popupBackground": "#ffffff",
    "popupColor": "#333333",
    "color": "#333333",
    "fontSize": 18,
    "fontFamily": "Helvetica Neue,Helvetica,Arial,sans-serif",
    "textAlign": "left",
    "paddingTop": 5,
    "paddingBottom": 5,
    "paddingLeft": 6,
    "paddingRight": 6,
    "selectedOptionColor": "#333333",
    "selectedOptionBackground": "#f2f2f2"
}

const checkboxStyle = {
    "borderTopRightRadius": 5,
    "borderTopLeftRadius": 5,
    "borderBottomRightRadius": 5,
    "borderBottomLeftRadius": 5,
    "borderTopWidth": 1,
    "borderBottomWidth": 1,
    "borderRightWidth": 1,
    "borderLeftWidth": 1,
    "borderTopColor": "#333333",
    "borderBottomColor": "#333333",
    "borderRightColor": "#333333",
    "borderLeftColor": "#333333",
    "background": "#ffffff",
    "color": "#333333",
    "colorButton": "#333333"
}

const radioBoxStyle = checkboxStyle


const defaultStyleKeys = [
    'borderBottomLeftRadius',
    'borderBottomRightRadius',
    'borderTopLeftRadius',
    'borderTopRightRadius',
    'borderBottomWidth',
    'borderRightWidth',
    'borderLeftWidth',
    'borderTopWidth',

    'borderTopStyle',
    'borderBottomStyle',
    'borderRightStyle',
    'borderLeftStyle',

    'borderTopColor',
    'borderRightColor',
    'borderBottomColor',
    'borderLeftColor',

    'textAlign',
    "verticalAlign"
]

const paddingKeys = [
    'paddingTop',
    'paddingBottom',
    'paddingRight',
    'paddingLeft',
]

const pixelStyles = new Set([
    'borderBottomLeftRadius',
    'borderBottomRightRadius',
    'borderTopLeftRadius',
    'borderTopRightRadius',
    
    'borderBottomWidth',
    'borderRightWidth',
    'borderLeftWidth',
    'borderTopWidth',

    'paddingTop',
    'paddingBottom',
    'paddingRight',
    'paddingLeft',

    'fontSize',
])

export function getDefaultStyle() {

    return {
        Label: labelStyle,
        Container: containerStyle,
        Button: buttonStyle,
        Default: defaultStyle,
        Screen: screenStyle,
        TextBox: textboxStyle,
        Table: tableStyle,
        Image: defaultImage,
        DropDown: dropdownStyle,
        CheckBox: checkboxStyle,
        RadioBox: radioBoxStyle
    }

}

export function getCustomStyle(app, topN = 2) {
    const counts = getCustomStyleCounts(app, topN)

    return {
        Label: countToStyle(counts.Label),
        Container: countToStyle(counts.Container),
        Button: countToStyle(counts.Button),
        Default: countToStyle(counts.Default),
        Screen: countToStyle(counts.Screen),
        TextBox: countToStyle(counts.TextBox),
        Table: countToStyle(counts.Table),
        Image: countToStyle(counts.Image),
        DropDown: countToStyle(counts.DropDown),
        CheckBox: countToStyle(counts.CheckBox),
        RadioBox: countToStyle(counts.RadioBox),
    }
}

function countToStyle(counts) {
    const result = {}

    for (let key in counts) {
        const values = counts[key]
        if (values.length > 0) {
            let value = values[0]
            if (pixelStyles.has(key)) {
                value = value * 1
            }
            result[key] = value
        }
    }
    return result
}

export function getCustomStyleCounts(app, topN = 2) {
    const result = {
    }
   
    result.Label = getMostUsedStyles(getLabels(app), ['color'], topN)
    result.Container = getMostUsedStyles(getContainer(app), ['background', ...defaultStyleKeys], topN)
    result.Button = getMostUsedStyles(getButtons(app), ['background', 'color',... defaultStyleKeys], topN)
    result.Default = getMostUsedStyles(Object.values(app.widgets), ['color', 'background', ...defaultStyleKeys], topN)
    result.Screen = getMostUsedStyles(Object.values(app.screens), ['background'], topN)
    result.TextBox = getMostUsedStyles(getInputs(app), ['background', 'color', ...defaultStyleKeys, ...paddingKeys], topN)
    result.Table = getMostUsedStyles(getTable(app), ['background', 'color', 'headerBackground', 'headerColor', ...defaultStyleKeys], topN) 
    result.CheckBox = getMostUsedStyles(getCheckBox(app), ['color', 'colorButton', 'background', ...defaultStyleKeys], topN)
    result.RadioBox = getMostUsedStyles(getRadioBox(app), ['color', 'colorButton', 'background', ...defaultStyleKeys], topN)
    result.DropDown = getMostUsedStyles(getDropDown(app), ['color', 'background', ...defaultStyleKeys], topN)
    result.Image = getMostUsedStyles(getImage(app), [], topN)

    return result
}

function getImage(app) {
    return Object.values(app.widgets).filter(widget => {
        return widget.type === 'Image'
    })
}

function getDropDown(app) {
    return Object.values(app.widgets).filter(widget => {
        return widget.type === 'DropDown'
    })
}

function getCheckBox(app) {
    return Object.values(app.widgets).filter(widget => {
        return widget.type === 'CheckBox' || widget.type === 'LabeledCheckBox'
    })
}

function getRadioBox(app) {
    return Object.values(app.widgets).filter(widget => {
        return widget.type === 'RadioBox' || widget.type === 'LabeledRadioBox'
    })
}

function getTable(app) {
    return Object.values(app.widgets).filter(widget => {
        return widget.type === 'Table'
    })
}

export function getButtons(app) {
    return Object.values(app.widgets).filter(widget => {
        return isButton(widget)
    })
}

export function isButton(widget) {
    return widget.type === 'Button'
        && widget.props?.label
        && between(widget.w, 10, 200)
        && between(widget.h, 10, 100)
}


function getContainer(app) {
    return Object.values(app.widgets).filter(widget => {
        return isContainer(widget)
    })
}

export function isContainer(widget) {
    return widget.type === 'Button'
        && !widget.props?.label
        && widget.w > 200
        && widget.h > 200
}

function getLabels(app) {
    return Object.values(app.widgets).filter(widget => {
        return widget.type === 'Label'
    })
}


function getInputs(app) {
    return Object.values(app.widgets).filter(widget => {
        return widget.type === 'TextBox'
    })
}

function between(v, min, max) {
    return v >= min && v <= max
}

function getMostUsedStyles(elements, keys, topN) {
    const counts = {}
    elements.forEach(e => {
        const style = e.style
        keys.forEach(key => {
            const value = style[key]
            if (value) {
                if (!counts[key]) {
                    counts[key] = {}
                }
                if (!counts[key][value]) {
                    counts[key][value] = 0
                }

                counts[key][value]++
            }

        })
    })

    const result = {}
    keys.forEach(key => {
        const keyCounts = counts[key]
        if (keyCounts) {
            const pairs = Object.keys(keyCounts).map(key => {
                return { key: key, value: keyCounts[key] }
            })
            pairs.sort((a, b) => {
                return b.value - a.value
            })
            result[key] = pairs.slice(0, Math.min(topN, pairs.length)).map(e => e.key)
        }

    })
    return result
}
